import React from "react";
import { DIRECTORS, FOUNDATION_INFO } from "@/lib/initiatives";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      <section className="section-py">
        <div className="mx-auto max-w-5xl container-x">
          <div className="text-xs uppercase tracking-[0.24em] text-[#4A5568]">About us</div>
          <h1 className="mt-3 font-serif-display text-4xl md:text-6xl text-[#0A2540]">
            {FOUNDATION_INFO.tagline}
          </h1>
          <p className="mt-6 text-lg text-[#4A5568] max-w-3xl">
            UB Maitreya Foundation is a Section 8 non-profit registered in Mumbai, working
            across seven pillars — mental health, teen emotional intelligence, quality
            education, entrepreneur & MSME support, women's empowerment, natural farming,
            and civic sense.
          </p>
          <p className="mt-4 text-[#4A5568] max-w-3xl">
            We believe India rises when its people rise — quietly, with dignity, and with
            each other. Every programme we run is designed with the communities we serve
            and delivered in trusted partnership with local organisations, corporates and
            citizens like you.
          </p>
        </div>
      </section>

      <section className="section-py bg-white border-y border-[#0A2540]/10">
        <div className="mx-auto max-w-7xl container-x">
          <div className="text-xs uppercase tracking-[0.24em] text-[#4A5568]">Our directors</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl text-[#0A2540]">
            The leadership
          </h2>
          <div className="mt-12 grid md:grid-cols-2 gap-10">
            {DIRECTORS.map((d) => (
              <div
                key={d.name}
                data-testid={`about-director-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="grid grid-cols-3 gap-6"
              >
                <div className="col-span-1 aspect-[3/4] rounded-2xl overflow-hidden border border-[#0A2540]/10">
                  <img src={d.photo} alt={d.name} className="w-full h-full object-cover" />
                </div>
                <div className="col-span-2">
                  <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37]">{d.role}</div>
                  <h3 className="mt-1 font-serif-display text-2xl text-[#0A2540]">{d.name}</h3>
                  <p className="mt-3 text-[#4A5568] text-sm leading-relaxed">{d.bio}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-8 text-xs text-[#4A5568]/80">
            Placeholder portraits — foundation to upload official photos.
          </p>
        </div>
      </section>

      <section className="section-py">
        <div className="mx-auto max-w-5xl container-x">
          <div className="text-xs uppercase tracking-[0.24em] text-[#4A5568]">Credentials</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl text-[#0A2540]">
            Registered, approved, transparent.
          </h2>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {[
              ["Section 8 Company (CIN)", FOUNDATION_INFO.cin],
              ["PAN", FOUNDATION_INFO.pan],
              ["80G Approval No.", FOUNDATION_INFO.reg80g],
              ["Approval Date", FOUNDATION_INFO.reg80g_date],
              ["Valid AY", FOUNDATION_INFO.ay_validity],
              ["NGO Darpan ID", FOUNDATION_INFO.darpan],
            ].map(([k, v]) => (
              <div key={k} className="rounded-2xl border border-[#0A2540]/10 bg-white p-5">
                <div className="text-xs uppercase tracking-[0.18em] text-[#4A5568]">{k}</div>
                <div className="mt-1 font-medium text-[#0A2540]">{v}</div>
              </div>
            ))}
          </div>
          <div className="mt-10">
            <Link
              to="/donate"
              className="inline-flex items-center gap-2 rounded-full bg-[#0A2540] text-white px-8 py-3.5 font-medium hover:bg-[#D4AF37] hover:text-[#0A2540] transition-colors"
              data-testid="about-donate-btn"
            >
              Support our work
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
